/*
* Project: LegalPlace assistant
* File: src/redux/actions/document_state.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

// document_state (new | continue)
// contract id
// user-id
// continue-id uniqid

const NEW_DOCUMENT = 'NEW_DOCUMENT';
const CONTINUE_DOCUMENT = 'CONTINUE_DOCUMENT';
const SET_CONTRACT_NAME = 'SET_CONTRACT_NAME';
const SET_USER_ID = 'SET_USER_ID';
const SET_DOCUMENT_ID = 'SET_DOCUMENT_ID';


function newDocument() {
  return {
    type: NEW_DOCUMENT,
  };
}

function continueDocument(docid) {
  return {
    type: CONTINUE_DOCUMENT,
    id: docid,
  };
}

function setContractName(name) {
  return {
    type: SET_CONTRACT_NAME,
    name,
  };
}

function setUserId(uid) {
  return {
    type: SET_USER_ID,
    id: uid,
  };
}

function setDocumentId(uid) {
  return {
    type: SET_DOCUMENT_ID,
    doc: uid,
  };
}


export {
  NEW_DOCUMENT,
  CONTINUE_DOCUMENT,
  SET_CONTRACT_NAME,
  SET_USER_ID,
  SET_DOCUMENT_ID,
  // action builders
  newDocument,
  continueDocument,
  setContractName,
  setUserId,
  setDocumentId,
};



// WEBPACK FOOTER //
// ./src/redux/actions/document_state.js